import { render, staticRenderFns } from "./ai-products.vue?vue&type=template&id=56616d86&scoped=true"
import script from "./ai-products.vue?vue&type=script&lang=js"
export * from "./ai-products.vue?vue&type=script&lang=js"
import style0 from "./ai-products.vue?vue&type=style&index=0&id=56616d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56616d86",
  null
  
)

export default component.exports